(function() {
    $(document).ready(function() {
        $('ol[start]').each(function() {
            const val = parseFloat($(this).attr('start')) - 1;
            $(this).css('counter-increment', 'numList ' + val);
        });
    });
})();

